@if (rootModel()) {
<div class="role-tree">
    <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'"
        [style.top]="menuPosition.y + 'px'"></span>
    <app-role-node [model]='rootModel()'></app-role-node>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-component="component" let-menu="menu">
            <button mat-menu-item [disabled]="!menu.unit" (click)="onUnit()">
                <mat-icon>folder_shared</mat-icon>
                <span>New Unit</span>
            </button>
            <button mat-menu-item [disabled]="!menu.role" (click)="onRole()">
                <mat-icon>supervisor_account</mat-icon>
                <span>Add Role</span>
            </button>
            <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
                <mat-icon>close</mat-icon>
                <span>Delete</span>
            </button>
            <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
                <mat-icon>flip_to_front</mat-icon>
                <span>Cut</span>
            </button>
            <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
                <mat-icon>flip_to_back</mat-icon>
                <span>Copy</span>
            </button>
            <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
                <mat-icon>library_add</mat-icon>
                <span>Paste</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
}
